import React, { useState, useEffect } from 'react';
import './Header.css';

const Header = () => {
  const [isScrolled, setIsScrolled] = useState(false);
  const [isMobileMenuOpen, setIsMobileMenuOpen] = useState(false);

  useEffect(() => {
    const handleScroll = () => {
      setIsScrolled(window.scrollY > 50);
    };

    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  const toggleMobileMenu = () => {
    setIsMobileMenuOpen(!isMobileMenuOpen);
  };

  const scrollToSection = (sectionId) => {
    const element = document.getElementById(sectionId);
    if (element) {
      element.scrollIntoView({ behavior: 'smooth' });
    }
    setIsMobileMenuOpen(false);
  };

  return (
    <header className={`header ${isScrolled ? 'scrolled' : ''}`}>
      <div className="container">
        <nav className="nav">
          <div className="nav-brand">
            <div className="logo">
              <img src="/logo.png" alt="ELIBS SOLUTIONS" className="logo-image" />
            </div>
          </div>
          
          <div className={`nav-menu ${isMobileMenuOpen ? 'active' : ''}`}>
            <a href="#home" className="nav-link" onClick={() => scrollToSection('home')}>
              Home
            </a>
            <a href="#services" className="nav-link" onClick={() => scrollToSection('services')}>
              Services
            </a>
            <a href="#about" className="nav-link" onClick={() => scrollToSection('about')}>
              About
            </a>
            <a href="#team" className="nav-link" onClick={() => scrollToSection('team')}>
              Team
            </a>
            <a href="#reference-projects" className="nav-link" onClick={() => scrollToSection('reference-projects')}>
              Projects
            </a>
            <a href="#gallery" className="nav-link" onClick={() => scrollToSection('gallery')}>
              Gallery
            </a>
            <a href="#contact" className="nav-link" onClick={() => scrollToSection('contact')}>
              Contact
            </a>
          </div>
          
          <div className="nav-actions">
            <button 
              className="btn btn-primary"
              onClick={() => {
                const element = document.getElementById('contact');
                if (element) {
                  element.scrollIntoView({ behavior: 'smooth' });
                }
              }}
            >
              Contact Us
            </button>
            <button 
              className="mobile-menu-toggle"
              onClick={toggleMobileMenu}
              aria-label="Toggle mobile menu"
            >
              <span></span>
              <span></span>
              <span></span>
            </button>
          </div>
        </nav>
      </div>
    </header>
  );
};

export default Header;
